import { useTranslation } from "react-i18next";
import { BankCardIcon, CartIcon, CashIcon } from "@/shared/icons";
import Button from "@/shared/ui/button/Button";
import { CartItem } from "@/domains/shop/constants/cartItem";
import { GoodsItem } from "@/domains/shop/constants/goodsItem";
import ShopCartItemsControls from "@/domains/shop/components/ShopCartItemsControls";

type Props = {
  goods: GoodsItem;
  cartList: CartItem[];
  handleCart: (item: GoodsItem) => void;
  handleIncrement: (id: number) => void;
  handleDecrement: (id: number) => void;
  onPayCash?: () => void;
  onPayCard?: () => void;
  isPaying?: boolean;
};

export default function ShopPaymentsButtons({
  goods,
  cartList,
  handleCart,
  handleIncrement,
  handleDecrement,
  onPayCash,
  onPayCard,
  isPaying,
}: Props) {
  const { t } = useTranslation("shop");
  const cartItem = cartList.find((item) => item.id === goods.id);
  const isInCart = Boolean(cartItem);

  return (
    <div className="flex gap-2">
      <Button
        className="w-10.5 h-10.5 rounded-xl"
        icon
        onClick={onPayCash}
        disabled={!onPayCash || isPaying}
      >
        <CashIcon className="size-5.5" />
      </Button>
      <Button
        className="w-10.5 h-10.5 rounded-xl"
        icon
        variant="solid-surface-gradient"
        onClick={onPayCard}
        disabled={!onPayCard || isPaying}
      >
        <BankCardIcon className="size-5.5" />
      </Button>

      {isInCart ? (
        <ShopCartItemsControls
          cartItem={cartItem}
          handleIncrement={handleIncrement}
          handleDecrement={handleDecrement}
        />
      ) : (
        <Button
          className="gap-2.5 grow h-10.5 leading-none rounded-xl"
          onClick={() => handleCart(goods)}
        >
          <CartIcon className="size-4.5" />
          {t("cart.cardButton")}
        </Button>
      )}
    </div>
  );
}
